import React, { useMemo } from "react";
import _ from "lodash";
import { Button } from "antd";
import moment from "moment";

import KonuxLogo from "../../images/konux_logo.svg";

export const getKonuxStatusFromHealthValue = (healthValue) => {
    if (healthValue === 3) {
        return {
            value: "Poor",
            color: "#ce3b3b",
        };
    } else if (healthValue === 2) {
        return {
            value: "At Risk",
            color: "#e38029",
        };
    } else if (healthValue === 1) {
        return {
            value: "Healthy",
            color: "#34bb43",
        };
    } else if (healthValue === 0) {
        return {
            value: "Unknown",
            color: "#888",
        };
    }

    return {
        value: "Unknown",
        color: "#888",
    };
};

export const getKonuxStatusFromDisplacement = (displacement) => {
    if (displacement < 3) {
        return {
            color: "#34bb43",
        };
    } else if (displacement < 4) {
        return {
            color: "#e38029",
        };
    } else if (displacement > 4) {
        return {
            color: "#ce3b3b",
        };
    }
    return { color: "#888" };
};

const KonuxAssetTab = ({ asset, goToSession }) => {
    const konuxData = useMemo(() => {
        let data = {};

        if (asset.data) {
            data = JSON.parse(asset.data);
        }

        return data;
    }, [asset.data]);

    const healthElements = useMemo(() => {
        const elements = [];
        const healthDisplacementData = _.get(konuxData, ["KONUX_HEALTH"], {});

        const health = _.get(healthDisplacementData, ["health"]);
        const displacement = _.get(healthDisplacementData, ["displacement"]);
        const timestamp = _.get(healthDisplacementData, ["timestamp"]);

        if (!_.isNil(health)) {
            const statusData = getKonuxStatusFromHealthValue(health);
            const elem = (
                <div className="InfoItem">
                    <div className="KeyContainer">
                        <div
                            className="ColourContainer"
                            style={{ background: statusData.color }}></div>
                        <p className="InfoItem Title">Current Status:</p>
                    </div>
                    <p className="InfoItem Value">{statusData.value}</p>
                </div>
            );

            elements.push(elem);
        }

        if (!_.isNil(displacement)) {
            const displacementData = getKonuxStatusFromDisplacement(displacement);

            const elem = (
                <div className="InfoItem">
                    <div className="KeyContainer">
                        <div
                            className="ColourContainer"
                            style={{ background: displacementData.color }}></div>

                        <p className="InfoItem Title">Displacement:</p>
                    </div>

                    <p className="InfoItem Value">{Math.round(displacement * 100) / 100}mm</p>
                </div>
            );

            elements.push(elem);
        }

        if (!_.isNil(timestamp)) {
            const elem = (
                <div className="InfoItem">
                    <div className="KeyContainer">
                        <p className="InfoItem Title">Data Updated:</p>
                    </div>

                    <p className="InfoItem Value">{moment(timestamp * 1000).fromNow()}</p>
                </div>
            );

            elements.push(elem);
        }

        return elements;
    }, [konuxData]);

    const deviceInfoElements = useMemo(() => {
        const elements = [];

        Object.keys(konuxData).forEach((key) => {
            const value = konuxData[key];

            if (typeof key !== "string" || typeof value !== "string") {
                return;
            }

            if (key.charAt(0) === "~") {
                return;
            }
            if (_.isNil(value)) {
                return;
            }

            elements.push(
                <div className="InfoItem">
                    <p className="InfoItem Title">{_.startCase(key)}:</p>
                    <p className="InfoItem Value">{value}</p>
                </div>,
            );
        });

        return elements;
    }, [konuxData]);

    const onKonuxClick = () => {
        const link = _.get(konuxData, ["~KONUX Link"]);

        if (link) {
            window.open(link);
        }
    };

    return (
        <div className="KonuxAssetContainer">
            <h1>{_.get(asset, ["description"])}</h1>

            <div className="HealthContainer">
                <p className="ContainerTitle">Health & Displacement</p>
                {healthElements}
            </div>

            <div className="ButtonContainer">
                <Button
                    type="primary"
                    onClick={onKonuxClick}
                    className="Button">
                    Open In Konux
                    <img
                        src={KonuxLogo}
                        className="KonuxLogo"
                        alt="Konux"
                    />
                </Button>

                <Button
                    onClick={goToSession}
                    type="primary"
                    className="Button">
                    View In AIVR Session
                </Button>
            </div>

            <div className="DeviceInfoContainer">
                <p className="ContainerTitle">Device Info</p>
                {deviceInfoElements}
            </div>
        </div>
    );
};

export default KonuxAssetTab;
